<template>
	<v-container grid-list-md class="white--text">
		<v-layout row wrap>
			<v-flex xs12 sm3 md3>
				<app-profile-menu
					:customer="$page.props.auth.customer.display_name"
					:customer_image="$page.props.auth.customer_image"
				></app-profile-menu>
			</v-flex>
			<v-flex xs12 sm9 md9>
				<v-layout row wrap justify-center align-center>
					<v-flex xs4 md5>&nbsp;</v-flex>
					<v-flex xs4 md2>
						<v-img :src="logo" width="auto" height="auto"></v-img>
					</v-flex>
					<v-flex xs4 md5>&nbsp;</v-flex>
					<v-flex xs12>
						<div class="text-center">
							<p>
								Thalias is committed to being recognized as the
								premier hospitality company in cambodia. <br />
								Our goal is for hotel and restaurants to be the
								first choice for fine food and hospitality
								lovers.
								<br />
								Thalias' mission in to nurture every person in
								our care towards a state of fulfilment.
							</p>
							<h2 class="secondary--text">សេវាបំរើអតិថិជន</h2>
							<h1 class="secondary--text">016 780 888</h1>
						</div>
						<div class="text-center mt-5">
							<h3>សម្រាប់ព័ត៌មានបន្ថែម</h3>
							<v-row align="center" justify="center" class="mt-5">
								<a
									href="https://www.facebook.com/thaliashospitality"
									target="_blank"
									class="mx-2"
								>
									<v-icon size="50" color="white"
										>mdi-facebook</v-icon
									>
								</a>
								<a
									href="https://www.instagram.com/thaliashospitality/"
									target="_blank"
									class="mx-2"
								>
									<v-icon size="50" color="white"
										>mdi-instagram</v-icon
									>
								</a>
								<a
									href="https://www.linkedin.com/company/thalias"
									target="_blank"
									class="mx-2"
								>
									<v-icon size="50" color="white"
										>mdi-linkedin</v-icon
									>
								</a>
							</v-row>

							<p class="secondary--text mt-5 font-weight-bold">
								info@thailashospitalit.com
							</p>

							<p class="caption mt-3">
								House 41,St. 13 Oknha Santhormok (St. 98), Phnom
								Penh, Cambodia
							</p>
						</div>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
	export default {
		data() {
			return {
				logo: this.$page.props.assets.logo,
			};
		},
	};
</script>